import deleteIcon from '@/core/assets/images/icons/delete.svg';

const DeleteBtn = ({ props, listeners }) => {
    const { className } = props;

    const classes = [...className];

    return (
        <button
        class={['l-ss-c-delete-btn', ...classes]}
        onClick={listeners.click}>
            <i domPropsInnerHTML={deleteIcon}></i>
        </button>
    );
};

DeleteBtn.props = {
    className: {
        type: [Object, String],
        default: '',
    },
};

export default DeleteBtn;
